export enum USER_ACTION_TYPES {
  SET_USER = "user/SET_USER",
  SET_EMAIL = "user/SET_EMAIL",
  SET_TMP = "user/SET_TMP",
  REMOVE_USER = "user/REMOVE_USER",
  REMOVE_TMP = "user/REMOVE_TMP",
  UPDATE_USER = "user/UPDATE_USER",
}
